import React from 'react'
import { FormattedMessage } from 'react-intl'

export default [
    {
        title: <FormattedMessage id={'Sidebar.letter'} />,
        icon: 'file-add',
        childrens: [
            {
                title: <FormattedMessage id={'Model.instructionletter.list'} />,
                path: '/model/instructionletter',
            },
            {
                title: <FormattedMessage id={'Model.quote.list'} />,
                path: '/model/quote',
            },
            {
                title: <FormattedMessage id={'Model.arrivalnotification.list'} />,
                path: '/model/arrivalnotification',
            },
        ],
    }
]


// WEBPACK FOOTER //
// ./src/containers/SideBar/menus/letter.js